import { baseUrl, manifestUrl } from "./config/config";

export class Modal {
    constructor(...args: any) {
        const manifestScript = document.createElement('script')
        manifestScript.src = `${manifestUrl}?t=${Date.now()}`
        document.head.appendChild(manifestScript)
        
        manifestScript.addEventListener('load', () => {
            const manifest = window.__ACIMA_ASSET_MANIFEST__
            if(!manifest['modal.js']) {
                console.error('manifest does not contain modal.js')
            }
            const acimaScript = document.createElement('script')
            acimaScript.src = `${baseUrl}/${manifest['modal.js']}`;
            document.head.appendChild(acimaScript)
            acimaScript.addEventListener('load', () => {
                new AcimaModal.Modal(...args)
            });

        })

        manifestScript.addEventListener('error', function (e) {
            console.error('Acima manifest failed to load', e);
        });
    }
}